import { ComponentProps, FC, ReactElement } from 'react'
import cn from 'classnames'

import Button from 'components/features/pfm/Button/Button'

import styles from 'components/features/rewards/rewardsPane/components/CryptoRewardsPaneLinkButton/CryptoRewardsPaneLinkButton.styl'

type CryptoRewardsPaneLinkButtonProps = ComponentProps<typeof Button>

export const CryptoRewardsPaneLinkButton: FC<CryptoRewardsPaneLinkButtonProps> = (props): ReactElement => (
  <Button size='mini' style='textOnly' { ...props } className={ cn(props.className, styles.linkButton) }>
    { props.children }
  </Button>
)
